import { render, staticRenderFns } from "./sertificates-import.vue?vue&type=template&id=58b1d692&scoped=true"
import script from "./sertificates-import.vue?vue&type=script&lang=ts"
export * from "./sertificates-import.vue?vue&type=script&lang=ts"
import style0 from "./sertificates-import.vue?vue&type=style&index=0&id=58b1d692&prod&lang=css&scoped=true"
import style1 from "./sertificates-import.vue?vue&type=style&index=1&id=58b1d692&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1d692",
  null
  
)

export default component.exports